import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    buttonClassName,
    labelClassName,
    pxArrayToRem,
    boxClassName,
} from '@archipro-design/aria';

export const DescriptionDesktopContainer: StyleRule = () => ({
    [`& p`]: {
        marginTop: 0,
        marginBottom: pxToRem(20),
        height: '100%',
    },
    fontSize: pxToRem(16),
});

export const AboutTextContent: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    padding: pxArrayToRem([39, 18, 60, 18]),
    display: 'block',

    [`& .${buttonClassName}`]: {
        marginTop: pxToRem(39),
        alignSelf: 'self-start',
        textTransform: 'none',
        height: '100%',
        padding: 0,
        minHeight: pxToRem(18),
        '&:hover': {
            backgroundColor: 'transparent',
        },
        [`& .${labelClassName}`]: {
            fontSize: pxToRem(14),
            letterSpacing: 0,
            textDecoration: 'underline',
            textUnderlineOffset: pxToRem(2),

            lineHeight: '1.3',
            textDecorationThickness: '1px',

            [screen.tablet]: {
                fontSize: siteVariables.fontSizes.caption03,
                lineHeight: '100%',
                textDecorationThickness: '2px',
            },
        },
    },
    [`& [aria-expanded="false"] .${boxClassName}`]: {
        '& *': {
            paddingBottom: 0,
        },
        '& p': {
            marginBlockStart: 0,
            '&:last-child': {
                marginBlockEnd: 0,
                paddingBottom: 0,
            },
        },
    },

    [screen.tablet]: {
        padding: 0,
        [`& .${buttonClassName}`]: {
            marginTop: 0,
        },
    },
});

export const ReadMoreContent: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    '& div': {
        color: siteVariables.colors.charcoal[250],
    },
    '& a': {
        textDecoration: 'underline',
        color: siteVariables.colors.charcoal[250],
        '&:hover': {
            color: siteVariables.colors.primitive.black,
        },
    },
    [screen.tablet]: {
        ['&.' + boxClassName]: {
            '& > :not(:first-child)': {
                paddingTop: `1.3em`,
            },
        },
    },
});

export const ReadMoreBlurb: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    fontSize: pxToRem(14),
    lineHeight: siteVariables.lineHeightSmall,
    color: siteVariables.colors.charcoal['000'],
    [screen.desktop]: {
        fontSize: pxToRem(16),
        lineHeight: `1.5`,
    },
});
